import React, { useEffect } from 'react'

import { THEMES } from '@/constants'
import variants from '@/theme/variants'

const initialState = {
  theme: THEMES.LIGHT,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTheme: (theme: string) => {},
}
const ThemeContext = React.createContext(initialState)

type ThemeProviderProps = {
  children: React.ReactNode
}

const getUserDefaultTheme = () => {
  const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)')
  return darkThemeMq.matches ? THEMES.DARK : THEMES.LIGHT
}

function ThemeProvider({ children }: ThemeProviderProps) {
  const userTheme = getUserDefaultTheme()
  const [theme, _setTheme] = React.useState<string>(userTheme)

  const setTheme = (theme: string) => {
    localStorage.setItem('theme', JSON.stringify(theme))
    const themeConfig = variants.find(variant => variant.name === theme)

    if (themeConfig) {
      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', themeConfig.header.background)
    }

    _setTheme(theme)
  }

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme')

    if (storedTheme) {
      setTheme(JSON.parse(storedTheme))
    }
  }, [])

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeProvider }
